// src/pages/produtos/combos/ApresentacaoSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useApresentacao } from '../../../contexts/produtos/combos/ApresentacaoContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalTable from '../../../components/modalForm/ModalTable';
import LazyLoading from '../../../components/modalForm/LazyLoading';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const ApresentacaoSearch = ({ show, onHide, onSelectApresentacao }) => {
    const { apresentacoes } = useApresentacao();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');

            inputRef.current?.focus();
        }
    }, [show]);

    const filtered = apresentacoes.filter(a => a.nome?.toLowerCase().includes(filter.toLowerCase()));
    const sorted = [...filtered].sort((a, b) => {
        if (sortField === 'id') return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        if (sortField === 'nome') return sortDirection === 'asc'
            ? a.nome.localeCompare(b.nome)
            : b.nome.localeCompare(a.nome);
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(dir => dir === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (apresentacao) => {
        onSelectApresentacao(apresentacao);
        onHide();
    };

    return show && (
        <ModalContainer show={show} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Apresentação" onHide={onHide} />
            <ModalBody>
                <ModalSearchBar
                    inputRef={inputRef}
                    type="text"

                    placeholder="Filtrar por nome..."
                    value={filter}
                    onChange={e => setFilter(e.target.value)}
                />
                <LazyLoading items={sorted} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} className="btn btn-link" type="button">Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start" aria-sort={sortField === 'nome' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('nome')} className="btn btn-link" type="button">Nome
                                    {sortField === 'nome' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center modal-select-column">Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map(a => (
                            <tr key={a.id} onDoubleClick={() => handleDoubleClick(a)}>
                                <td className="text-end">{a.id}</td>
                                <td>{a.nome}</td>
                                <td className="text-center modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectApresentacao(a)} label={a.nome} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter>

                <ModalActionButton type='button' className="btn btn-secondary btn-sm" onClick={onHide} action="close">Fechar</ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default ApresentacaoSearch;